export class CandidateAdditionalDetails {
    constructor() {
        this.candidateId = null;
        this.salary = null;
        this.sponsorships = [];
        this.sponsorshipsNote = null;
        this.willingToRelocate = null;
        this.relocationNote = null;
        this.additionalInformation = null;
        this.workLocations = null;
    }
}
//# sourceMappingURL=candidateAdditionalDetails.js.map